import { Observable } from "rxjs";
import { WorkFlowData } from "../components/campaign-tabs/campaign-workflow-tab/work-flow-component/workflow.interface";

export interface Day {
    day: string;
    isSelected: boolean;
    value: string;
}
export interface SmsContent {
    language: string;
    notes: string;
    isSelected: boolean;
    isDefault: boolean;
    isAvailable?: boolean;
    mmsImageUrl?: string | null;
    mmsImageFileName?: string | null;
}
export interface VoiceContent {
    language: string;
    notes: string;
    isSelected: boolean;
    isDefault: boolean;
    isAvailable?: boolean;
}
export interface EmailContent {
    contentHtml?: string;
    contentJSON?: object;
    emailSubject?: string;
    emailDisplayName?: string;
    emailPreviewText?: string;
    selectedLanguage?: string;
    replyToEmailAddress?: string;
    fromEmailAddress?: string;
    counter?: number;
}

export interface NodeLabelUpdate {
  stateId: string;
  label: string;
}

export interface CampaignAuditHistory {
  heading: string;
  labels: string[];
  changes: string[];
  sourceCampaignId: string | null;
}

export interface AuditHistoryParsed {
  heading: string;
  labels: string[];
  changes: string[];
  sourceCampaignId: string | null;
}

export interface AuditHistoryRecord {
  id: string;
  campaignId: string;
  status: string;
  auditHistory: AuditHistoryParsed | null;
  createdById: string;
  createdDateTimeUtc: string;
  createdByUserName: string;
  sourceCampaignName: string;
}
export type CommunicationChannel = 'EMAIL' | 'SMS';

export interface CommunicationHistoryRecord {
  campaignTaskId: string;
  campaignName: string;
  sentDateTime: string;
  listName: string | null;
}

export interface CommunicationHistorySearchParams {
  channel: CommunicationChannel;
  contact: string;
  campaignName?: string;
  listName?: string;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  limit: number;
}

export interface CommunicationDetail {
  subject: string | null;
  status: string | null;
  emailContent: string | null;
  isUnsubscribed: number;
  fromEmailAddress: string | null;
  contentJSON?: any | null;
}

export interface SmsCommunicationDetail {
  smsContent: string | null;
  mediaUrl: string | null;
  status: string | null;
  isUnsubscribed: number;
  fromPhoneNumber: string | null;
}

export interface CampaignDetails {
    campaignName?: string; // Use optional property
    description: string;
    emailDisplayName: string;
    emailSubject: string;
    emailPreviewText: string;
    selectedLanguage?: string;
    replyToEmailAddress: string;
    fromEmailAddress: string;
    emailContent: {
        contentHtml: string;
        contentJSON: object;
        counter: number;
        pendingImageCount: number;
        uploadedImageCount: number;
    };
    selectedLists: SelectedListItem[]
    settings: {
        timezone?: string;
        sendOn: Day[];
        timeInterval: {
            from: string;
            to: string;
        };
        throttling: {
            enabled: boolean;
            hourlyLimit: number | null;
        };
        startDate: {
            enabled: boolean;
            date: string;
        };
        endDate: {
            enabled: boolean;
            date: string;
        };
    };
    smsContent: SmsContent[];
    voiceContent: VoiceContent[];
    status: string;
    isResumed: boolean;
    oldChannels:enableChannel;
    selectedChannels:enableChannel;
    isArchived : boolean;
    isReportingDisabled : boolean;
    usingCampaignWorkflow : boolean;
    workflowData? : (WorkFlowData & { workflowDescription?: string }) | null;
    workflowCommunications? : any
}

export interface SelectedListItem {
    id: string;
    isSelected?: boolean;
    fileName: string;
    createdDateTimeUtc?: string;
    totalRows?: number;
    uniqueEmailCount?: number;
    uniquePhoneNumberCount?: number;
    isArchived?: boolean;
}

export interface selectList {
    selectedListsCount: number;
    isSelectAll: boolean;
    search: string;
    lists: selectedList[];
    page: number;
    sortBy: string;
    sortOrder: string;
    limit: number;
    totalRecords: number;
}

export interface selectedList {
    id: string;
    isSelected: boolean;
    fileName: string;
    createdDateTimeUtc: string;
    totalRows: number;
    uniqueEmailCount?: number;
    isArchived?: boolean;
    uniquePhoneNumberCount?: number;
}

export interface archivedListItem {
    id: string;
    isSelected: boolean;
    fileName: string;
    createdDateTimeUtc: string;
    totalRows: number;
    uniqueEmailCount?: number;
    uniquePhoneNumberCount?: number;
    archivedDateTimeUtc: string;
    archivedBy: {
        id: string;
        displayName: string;
        userName: string;
    }
}

export interface archivedSelectList {
    selectedListsCount: number;
    isSelectAll: boolean;
    search: string;
    lists: archivedListItem[];
    page: number;
    sortBy: string;
    sortOrder: string;
    limit: number;
}

export interface PatientListResponse {
   isActionSuccess: boolean;
    errors: any;
    data: {
        records: archivedListItem[];
        count: number;
        archivedTotalCount: number;
        activeTotalCount: number;
        defaultTimeZone: string;
        enableSecureDriveImport: boolean;
    }
}

export interface pageObject {
    pageNum: number,
    selected: boolean,
}
export interface IVRMessages {
    english: string;
    spanish: string;
    russian: string;
}
export interface SMSMessages {
    english: string;
    spanish: string;
    russian: string;
}

export interface Languages {
    code: string;
    name: string;
    default: boolean;
}

export interface enableChannel{
    sms:boolean;
    voice:boolean;
    email:boolean;
    mms?: boolean;
}


export interface smsAdmin {
    welcomeMessage:string;
    unSubscribedMessage:string;
    reSubscribeMessage:string;
    helpMessage:string;
    unknownMessage:string;

}


export interface BroadcastPermissions {
    FocusBroadCastIVR: boolean;
    FocusBroadCastSMS: boolean;
    FocusBroadCastMMS: boolean;
    isExternalOptOutEnabled:boolean,
    isCampaignWorkflowEnabled:boolean,
    FocusBroadCastAvailableLanguages: { [code: string]: boolean };
  }

  export interface CampaignListSorting {
    sortOrder : string,
    sortBy : string,
    columnName : string,
}


export interface UnsubscribeListSorting {
    sortOrder: string;
    sortBy: string;
    columnName: string;
}

export interface UnsubscribeDownloadSSE {
    url: string;
    fileName: string;
}
export enum UnsubscribeType {
    EMAIL = 'email',
    SMS = 'sms',
}
export interface DownloadOptOutsParam {
    search: string;
    type: UnsubscribeType;
    domainName?: string;
    startDate?: Date;
    endDate?: Date;
}
export interface DownloadAuditList {
    campaignId: string;
    fileId: string;
    listName: string;
    type: string;
}
export interface AuditListDownloadSSE {
    url: string;
    fileName: string;
}


export interface CampaignStatusConfirmationModalData {
  title?: string;
  campaignName: string;
  promptAction: string;
  confirmButtonText: string;
  successMessage: string;
  expiredWarningMessage?: string;
  onConfirm: () => Observable<any>;
}



export type SendTestGroupType = 'email' | 'sms';

export interface SendTestGroupPayload {
  groupName: string;
  type: SendTestGroupType;
  data: string[];
}

export interface SendTestGroupResponse {
  isActionSuccess: boolean;
  message: string;
}

export interface TestGroupApiItem {
  id: number;
  groupName: string;
  type: SendTestGroupType;
  data: string[];
}

export interface GetTestGroupsResponse {
  isActionSuccess: boolean;
  data: TestGroupApiItem[];
}
export type SendTestChannel = 'email' | 'sms' | 'mms';

export interface SendTestModalData {
  channel: SendTestChannel;
  // Email context
  html?: string;
  subject?: string;
  emailDisplayName?: string;
  emailPreviewText?: string;
  campaignId?: string;
  replyToEmailAddress?: string;
  fromEmailAddress?: string;
  // SMS / MMS context
  content?: string;
  type?: 'SMS' | 'MMS' | 'IVR';
  imageUrl?: string;
  imageFile?: File;
  isMMSEnabled?: boolean;
}
export type SendTestChipsMode = 'email' | 'phone';

export interface SendTestNewGroup {
  name: string;
  members: string[];
}

export interface UnsubscribeContent {
  unsubsConfirmationModalHeader: string;
  unsubsConfirmationModalContent: string;
  unsubsConfirmationModalFooter: string;
  unsubsSuccessfulHeader: string;
  unsubsSuccessfulContent: string;
  unsubsSuccessfulTestEmailContent: string;
}
export interface UnsubscribeLanguageOption { language: string; content: UnsubscribeContent; }
